
import { Component, Prop, Vue } from 'vue-property-decorator'
import { INewsData } from '@/types/home-types'

@Component({
    name: 'NewsList',
    components: {
    }
})
export default class extends Vue {
    @Prop({ required: true }) private newsList!: INewsData[]

    private onGoNewsDetail(id: string) {
        this.$router.push({ name: 'NewsDetail', params: { id } })
    }
}
